import { useState } from 'react';
import { useDIContext } from '@/Framework/DI/DIContext';
import StratsRepository from '@/finsight/infrastructure/repository/StratsRepository/StratsRepository';
import { ISummaryFilters } from '@/finsight/infrastructure/repository/StratsRepository/types';
import { getErrorMessage } from '@/Framework/Message/Mapper/getMessage';
import { AlertManager } from '@dealroadshow/uikit/core/components/Alert';
import { TFileId } from '@/finsight/domain/strats/types/SidebarStrats';

export const useStratsSummaryFilters = (initialSummaryFilters: ISummaryFilters[]) => {
  const stratsRepository = useDIContext().container.get(StratsRepository);
  const [summaryFilters, setSummaryFilters] = useState<ISummaryFilters[]>(initialSummaryFilters);
  const [summaryFiltersFetching, setSummaryFiltersFetching] = useState<boolean>(false);

  const getSummaryByFilters = async (fileId: TFileId, filters: number[] = []) => {
    setSummaryFiltersFetching(true);
    try {
      const response = await stratsRepository.getSummaryByFilters(fileId, filters);
      setSummaryFilters(response);
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
    } finally {
      setSummaryFiltersFetching(false);
    }
  };

  return {
    summaryFiltersFetching,
    summaryFilters,
    getSummaryByFilters,
  };
};
